import moment from 'moment';
moment.locale('zh-cn');

export const dateFormat = (value, format = 'YYYY-MM-DD') => {
    return value ? moment(value * 1000).format(format) : '';
}

export const yuan = (value) => {
    let val = 0;
    val = !isNaN(value) ? '¥' + Math.abs(parseFloat(value).toFixed(2)) : value;
    if (value < 0) {
        return '- ' + val;
    } else {
        return val;
    }
}
export const jifen = (value) => {
    let val = 0;
    let currencyName = localStorage.getItem('currency_name')
    let currencyRate = localStorage.getItem('currency_rate')
    if (currencyName && currencyName !== 'rmb' && currencyName !== '元') {
        val = !isNaN(value) ? (Math.abs(parseFloat(value).toFixed(2)) * currencyRate).toFixed(2) + currencyName : value;
    } else {
        val = !isNaN(value) ? '¥' + Math.abs(parseFloat(value).toFixed(2)) : value;
    }

    if (value < 0) {
        return '- ' + val;
    } else {
        return val;
    }
}
// 健管产品（product_mode 3=虚拟卡 4=实体卡）价格展示：1元=100积分，显示为“XX积分”；
// 非健管产品沿用原有 jifen 展示逻辑（¥XX）
export const healthPrice = (value, productMode) => {
    const mode = Number(productMode);
    const isHealth = mode === 3 || mode === 4;
    if (!isHealth) {
        return jifen(value);
    }
    if (isNaN(value)) {
        return value;
    }
    const points = parseFloat((Math.abs(parseFloat(value)) * 100).toFixed(2));
    return points + '积分';
}
export const rmb = (value) => {
    let val = 0;
    let currencyName = localStorage.getItem('currency_name')
    let currencyRate = localStorage.getItem('currency_rate')
    if (currencyName && currencyName !== 'rmb' && currencyName !== '元') {
        val = !isNaN(value) ? (Math.abs(parseFloat(value).toFixed(2)) * currencyRate).toFixed(2) + currencyName : value;
    } else {
        val = !isNaN(value) ? '¥' + parseFloat(value).toFixed(2) : value;
    }

    if (value < 0) {
        return '- ' + val;
    } else {
        return val;
    }
}

export const rate = (value) => {
    return !isNaN(value) ? (value / 10000).toFixed(2) * 100 + '%' : '';
}

export const dateFormat2 = (value, format = 'MM月DD日') => {
    return value ? moment(value * 1000).format(format) : ''
}
export const dayFormat = (value) => {
    let day = new Date(parseInt(value) * 1000).getDay()
    switch (day) {
        case 0:
            day = '周日'
            break
        case 1:
            day = '周一'
            break
        case 2:
            day = '周二'
            break
        case 3:
            day = '周三'
            break
        case 4:
            day = '周四'
            break
        case 5:
            day = '周五'
            break
        case 6:
            day = '周六'
            break
    }
    return day
}
export const dayFormat2 = (value) => {
    let day = new Date(Date.parse(value)).getDay()
    switch (day) {
        case 0:
            day = '[周日]'
            break
        case 1:
            day = '[周一]'
            break
        case 2:
            day = '[周二]'
            break
        case 3:
            day = '[周三]'
            break
        case 4:
            day = '[周四]'
            break
        case 5:
            day = '[周五]'
            break
        case 6:
            day = '[周六]'
            break
    }
    return day
}
export const dateAndDayFormat = (value) => {
    let day = new Date(parseInt(value) * 1000).getDay()
    var mydate = new Date();
    var myddy = mydate.getDay()
    if (myddy == day) {
        day = '今天'
        return day + dateFormat2(value)
    } else if (myddy == day - 1) {
        day = '明天'
        return day + dateFormat2(value)
    } else if (myddy == day - 2) {
        day = '后天'
        return day + dateFormat2(value)
    }
    switch (day) {
        case 0:
            day = '周日'
            break
        case 1:
            day = '周一'
            break
        case 2:
            day = '周二'
            break
        case 3:
            day = '周三'
            break
        case 4:
            day = '周四'
            break
        case 5:
            day = '周五'
            break
        case 6:
            day = '周六'
            break
    }
    return day + dateFormat2(value)
}
export const intYuan = (value) => {
    let val = ''
    val = !isNaN(value) ? '' + Math.abs(parseFloat(value).toFixed(0)) : value
    return val + '元'
}

export const kmFormat = (value) => {
    return !isNaN(value) ? (value / 1000).toFixed(2) : ''
}

export const mFormat = (value) => {
    return !isNaN(value) ? value.toFixed(2) : ''
}


export const phoneFormat = (value) => {
    return !isNaN(value) ? value.substring(0, 3) + '****' + value.substring(7, 11) : ''
}


export default {
    install(Vue) {
        Vue.filter('yuan', yuan)
        Vue.filter('intYuan', intYuan)
        Vue.filter('jifen', jifen)
        Vue.filter('healthPrice', healthPrice)
        Vue.filter('rmb', rmb)
        Vue.filter('rate', rate)
        Vue.filter('dateFormat', dateFormat)
        Vue.filter('dateFormat2', dateFormat2)
        Vue.filter('dayFormat', dayFormat)
        Vue.filter('dayFormat2', dayFormat2)
        Vue.filter('dateAndDayFormat', dateAndDayFormat)
        Vue.filter('kmFormat', kmFormat)
        Vue.filter('mFormat', mFormat)
        Vue.filter('phoneFormat', phoneFormat)

    }
}